import { render, staticRenderFns } from "./DSDealFields.vue?vue&type=template&id=df4b0e5e&"
import script from "./DSDealFields.vue?vue&type=script&lang=js&"
export * from "./DSDealFields.vue?vue&type=script&lang=js&"
import style0 from "./DSDealFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports